import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { VoucherRepository } from '@app/domain/ports/tpv/voucher.repository';
import { SendVoucherRequest, VoucherMode, VoucherUrlDto } from '@app/data/dtos/tpv/voucher.dto';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope, unwrapTpv } from '@app/data/tpv/tpv-envelope';
import { toHttpParams } from './tpv-http.util';

/**
 * Implementación HTTP de los comprobantes del TPV
 * (`api/v1/tpv/transactions/<id>/voucher/`). Auth vía interceptores estándar.
 */
@Injectable()
export class VoucherRemoteDataSource extends VoucherRepository {
  private readonly http = inject(HttpClient);

  override getVoucherUrl(idTransaction: string, mode: VoucherMode): Observable<string> {
    return this.http
      .get<TpvEnvelope<VoucherUrlDto>>(tpvUrl(`transactions/${idTransaction}/voucher/`), {
        params: toHttpParams({ mode }),
      })
      .pipe(map((raw) => unwrapTpv<VoucherUrlDto>(raw)?.url ?? ''));
  }

  override sendVoucher(idTransaction: string, request: SendVoucherRequest): Observable<void> {
    return this.http
      .post<TpvEnvelope<unknown>>(tpvUrl(`transactions/${idTransaction}/voucher/send/`), request)
      .pipe(map(() => void 0));
  }
}
